import {
  Component,
  ElementRef,
  inject,
  input,
  ChangeDetectionStrategy,
} from '@angular/core';

@Component({
  selector: 'fc-dialog-content',
  standalone: true,
  template: ` <ng-content /> `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class:
      'block overflow-auto overscroll-contain max-h-[100dvh] md:max-h-[80dvh] bg-white',
    '[class.p-24]': 'hasPadding()',
  },
})
export class DialogContentComponent {
  readonly hasPadding = input(true);

  private readonly host = inject<ElementRef<HTMLElement>>(ElementRef);

  scrollToTop(): void {
    const element = this.host.nativeElement;
    if (element.scrollTop === 0) return;
    element.style.overflow = 'hidden';
    element.scrollTop = 0;
    void element.offsetHeight;
    element.style.overflow = '';
  }
}
